export default {
  subscribers_gained: [],
  revenueGenerated: [],
  quarterlySales: [],
  ordersRecevied: [],
  revenueComparisonLine: []
}
